import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflow: "scroll !important",
    height: "100%",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  container: {
    marginTop: 70,
    padding: theme.spacing.space16,
  },
  disabled: {
    color: theme.colors.TextSilver,
  },
  btnContent: {
    display: "flex",
    padding: "12px 20px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    letterSpacing: "-0.9px",
    borderRadius: theme.spacing.space2,
    lineHeight: "21.6px",
  },
  redPrimaryButton: {
    background: theme.colors.background9 + " !important",
  },
  disabledButton: {
    background: theme.colors.ButtonDisable + " !important",
  },
}));
